/**
 * Prefer pipeline-written provenance.path; fall back to the free-form
 * Procedure.source_doc_id (best-effort — may 404 in the viewer).
 */
export function procedureViewerSourceFile(procedure: {
  provenance?: { source_file?: string }
  source_doc_id?: string
}): string | undefined {
  const fromProvenance = procedure.provenance?.source_file
  if (typeof fromProvenance === 'string' && fromProvenance.length > 0) return fromProvenance
  const fromDocId = procedure.source_doc_id
  if (typeof fromDocId === 'string' && fromDocId.length > 0) return fromDocId
  return undefined
}

export function procedureViewerSourcePage(procedure: {
  provenance?: { source_page?: number }
  source_doc_page?: number
}): number | undefined {
  return procedure.provenance?.source_page ?? procedure.source_doc_page
}
